import React from "react";
import { VStack } from "@chakra-ui/react";
import { AccordionItem, Form, TextInput } from "components";
import { useCurrentCase } from "duck";
import { useUpdateGeneralAssessment } from "../../duck";
import { FormValues, getDefaultValues } from "./duck";

const Reports: React.FC = () => {
  const generalAssessment = useCurrentCase(
    ({ data }) => data.client.patient.generalAssessment
  );

  const onChange = useUpdateGeneralAssessment();
  const defaultValues = getDefaultValues(generalAssessment);

  return (
    <AccordionItem title="Reports">
      <Form<FormValues> defaultValues={defaultValues}>
        <Form.Watcher defaultValues={defaultValues} onChange={onChange} />
        <VStack spacing="24px">
          <TextInput
            type="text-area"
            name="intraoralRadiographicComments"
            placeholder="Enter additional comments and notes"
            label="Intraoral Radiographic Comments"
          />
          <TextInput
            type="text-area"
            name="cbctComments"
            placeholder="Enter additional comments and notes"
            label="CBCT Comments"
          />
          <TextInput
            type="text-area"
            name="referralNotesAndComments"
            placeholder="Enter additional comments and notes"
            label="Referral notes and comments"
          />
          <TextInput
            type="text-area"
            name="notesForClientDentalReport"
            placeholder="Enter additional comments and notes"
            label="Notes for client  dental report"
          />
        </VStack>
      </Form>
    </AccordionItem>
  );
};

export default Reports;
